var AuthModule = /** @class */ (function () {
    function AuthModule() {
    }
    return AuthModule;
}());
export { AuthModule };
